/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "a087a44c1ddd48428fbf40771e50ba71",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "a087a44c1ddd48428fbf40771e50ba71",
            "region": "us-east-1"
        }
    },
    "aws_cognito_identity_pool_id": "us-east-1:4fb35ba6-6a14-4ffd-a2d1-096f9b888ff9",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_rngKPDqwM",
    "aws_user_pools_web_client_id": "4pvsi059a7cmrg6dq0mkbnsfv8",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "headstogetherdatalys-20220804123643-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d2slvrpxh7fvsi.cloudfront.net"
};


export default awsmobile;
